import "./App.css";
import { Header } from "./components/shared/header";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  useNavigate,
} from "react-router";
import Home from "./pages/Home/Home";
import { Footer } from "./components/shared/footer/Footer";
import Study from "./pages/Study/Study";
import { Main } from "./pages/Study/Main";
import Test from "./pages/Study/Test/Test";
import { Themes } from "./pages/Study/Themes/Themes";
import { Marathon } from "./pages/Study/Marathon";
import { Video } from "./pages/Study/Video";
import "video.js/dist/video-js.css";
import ModalProvider from "./components/shared/ModalProvider";
import Login from "./pages/Login/Login";
import User from "./pages/User/User";
import AlertProvider from "./components/shared/AlertProvider";
import { useEffect, useState } from "react";
import { usePortal, useUserStore } from "./hooks/store";
import { getToken } from "./utils/utils";
import LoadingPortal from "./components/shared/LoadingPortal/LoadingPortal.jsx";
import Pdd from "./pages/Study/Rules/Rules.jsx";
import DialogProvider from "./components/shared/DialogProvider.jsx";
import moment from "moment/moment.js";
import News from "./pages/News/News.jsx";
import "moment/locale/ru";
import Exam from "./pages/Study/Exam.jsx";
moment.locale("ru");

const Layout = () => {
  const userStore = useUserStore();
  const [isAuth, setIsAuth] = useState(false);
  const nav = useNavigate();
  const loading = usePortal();

  // useEffect(() => {
  //   loading.setPortal();
  //   userStore.checkMe().then(({ data, status }) => {
  //     switch (status) {
  //       case 200:
  //         userStore.login({ ...data, JWT: getToken() });
  //         break;
  //       case 426:
  //         nav("/login");
  //         break;
  //       default:
  //         break;
  //     }
  //     loading.closePortal();
  //     setIsAuth(true);
  //   });
  // }, []);

  return (
    <LoadingPortal>
      <AlertProvider>
        <ModalProvider>
          <DialogProvider>
            <Header />
            {/* {(isAuth && <Outlet />) || <main className="content"></main>}
            < */}

            <Outlet />
            {/* <Footer /> */}
          </DialogProvider>
        </ModalProvider>
      </AlertProvider>
    </LoadingPortal>
  );
};

export default function App() {
  /**
   *
   *
   * Старая навигация с полным набором страниц
   *
   */

  // const browserRouter = createBrowserRouter(
  //   [
  //     {
  //       path: "",
  //       Component: Layout,
  //       children: [
  //         {
  //           path: "/",
  //           Component: Home,
  //         },
  //         {
  //           path: "/news",
  //           Component: News,
  //         },
  //         {
  //           path: "/news/:newsId",
  //         },
  //         {
  //           path: "study",
  //           Component: Study,
  //           children: [
  //             {
  //               path: "bilet",
  //               index: true,
  //               Component: Main,
  //             },
  //             {
  //               path: "theme",
  //               index: true,
  //               Component: Themes,
  //             },
  //             {
  //               path: "marathon",
  //               index: true,
  //               Component: Marathon,
  //             },
  //             {
  //               path: "video",
  //               index: true,
  //               Component: Video,
  //             },
  //             {
  //               path: "pdd",
  //               index: true,
  //               Component: Pdd,
  //             },
  //             {
  //               path: "test",
  //               Component: Test,
  //             },
  //           ],
  //         },
  //         {
  //           path: "/user",
  //           Component: User,
  //         },
  //         {
  //           path: "/login",
  //           Component: Login,
  //         },
  //       ],
  //     },
  //   ],
  //   { basename: "/test_new_web_ui" },
  // );

  /**
   *
   *
   * Новая навигация с страницами только для обучения
   *
   */

  const browserRouter = createBrowserRouter(
    [
      // {
      //   path: "/",
      //   Component: Study,
      // },

      {
        path: "",
        Component: Layout,
        children: [
          {
            path: "/",
            Component: Study,
            children: [
              {
                path: "",
                index: true,
                Component: Main,
              },
              {
                path: "theme",
                index: true,
                Component: Themes,
              },
              {
                path: "marathon",
                index: true,
                Component: Marathon,
              },
              {
                path: "exam",
                index: true,
                Component: Exam,
              },
              {
                path: "video",
                index: true,
                Component: Video,
              },
              {
                path: "pdd",
                index: true,
                Component: Pdd,
              },
              {
                path: "test",
                Component: Test,
              },
            ],
          },
        ],
      },
    ],
    { basename: "/bilet-pdd" },
  );

  return <RouterProvider router={browserRouter}></RouterProvider>;
}
